import React, {useState} from 'react'
import {Box} from '@mui/material'
function HeaderBlock({id,type,properties}) {
  return (
    <Box sx={{
       textAlign: properties.textAlign || 'left',
       padding:  `${properties.padding.top}px ${properties.padding.right}px ${properties.padding.bottom}px ${properties.padding.left}px`,
       margin:  `${properties.margin.top}px ${properties.margin.right}px ${properties.margin.bottom}px ${properties.margin.left}px`,
       backgroundColor: properties.backgroundColor || 'transparent',
    }}>
    <Box
            component={properties.level || 'h1'}
            sx={{
              color: properties.color || '#000000',
              fontSize: properties.fontSize || '32px',
              fontWeight: properties.fontWeight || 'bold',
              fontFamily: properties.fontFamily || 'Arial, sans-serif',
              textDecoration: properties.textDecoration || 'none',
              lineHeight: properties.lineHeight || '1.5',
              whiteSpace: 'pre-wrap',
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
              hyphens: 'auto',
              maxWidth: '100%',
              boxSizing: 'border-box'
            }}
    
          >
            {properties.title || 'Header Text'}
          </Box>
          </Box>
  )
}

export default HeaderBlock